import { Divider } from '@mui/material';
import React from 'react'
import { Link } from 'react-router-dom';
import "../style/notification.css"

export default function Notifications({openNotifs, setOpenNotifs, notifications, setNotifications}) {
  
  const displayNotifs=(notif)=>{
    let _type;
    if(notif.type == 1){
      _type="liked"
    }
    else if(notif.type == 2){
      _type="commented"
    }
    console.log(notif)
    return(
    <>
    <Link className="notificationLink" to={`/blogs/${notif.blogId}`}><div className='notif'>{`${notif.senderId} ${_type} your post.`}</div></Link>
    <Divider/>
    </>
    )
  }

  const handleNotifsRead = () =>{
    setNotifications([])
    setOpenNotifs(false)
  }

  return (
    <>
    {openNotifs && <div className="notifs" >
          {notifications.length != 0 ?
          notifications.map((notif) => displayNotifs(notif))
          :
          "No new notifications to display"
          }
          <button className="readButton" disabled={notifications.length==0} onClick={handleNotifsRead}>
            Mark As Read
          </button>
      </div>
      }
    </>
  )
}
